import { render } from '@wordpress/element';
import { UserProvider } from './context/context';
import App from './components/App';
import './style.scss';

const TypologyTool = () => {
	return (
		<UserProvider>
			<App />
		</UserProvider>
	);
};

const mount = document.getElementById('js-typology-feature-update');
if (mount) {
	render(<TypologyTool />, mount);
}
